import cn from 'clsx'
import { VisuallyHidden } from '../visually-hidden'
import type { TSpinnerProps } from './Spinner.types'
import styles from './Spinner.module.css'

export const Spinner = ({ className }: TSpinnerProps) => (
    <div className={cn(styles.spinner, className)} role="status" aria-label="loading">
        <VisuallyHidden>Loading</VisuallyHidden>
    </div>
)
